import React, { useContext, useEffect, useMemo } from "react"
import { ScrollContext } from "../context"
import { CATALOG } from "../data/catalog"
import map from "lodash/map"
import mapValues from "lodash/mapValues"
import findKey from "lodash/findKey"
import { navigate as gatsbyNavigate } from "gatsby"
import Animator from "./Animator"

const Positioner = ({ location, navigate }) => {
  const { x, y, h, w, p, toX, toY } = useContext(ScrollContext)
  const ANIMATED_CATALOG = useMemo(() => {
    return mapValues(CATALOG, item => ({ ...item, Component: Animator(item.Component) }))
  }, [])

  useEffect(() => {
    const url = findKey(ANIMATED_CATALOG, (item, key) => item.y === p[1] && item.x === p[0])
    if (url && url !== location.pathname) {
      gatsbyNavigate(url)
    }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [p, ANIMATED_CATALOG])

  return (
    <>
      {map(ANIMATED_CATALOG, ({ x: pageX, y: pageY, Component, props }, url) => {

        //skip rendering items "too far"
        const deltaX = Math.abs(pageX - p[0])
        const deltaY = Math.abs(pageY - p[1])
        if(deltaX >= 2 || deltaY >= 2){
          return null
        }

        const top = y.interpolate(y => -Math.max(0, (y - pageY) * h))
        const bottom = y.interpolate(y => Math.max(0, (y - pageY) * h))
        const left = x.interpolate(x => -Math.max(0, (x - pageX) * w))
        const right = x.interpolate(x => Math.max(0, (x - pageX) * w))

        const planarTop = y.interpolate(y => -(y - pageY) * h)
        const planarBottom = y.interpolate(y => (y - pageY) * h)
        const planarLeft = x.interpolate(x => -(x - pageX) * w)
        const planarRight = x.interpolate(x => (x - pageX) * w)

        const xIsIncreasing = x.interpolate((x) => x < toX)
        const yIsIncreasing = y.interpolate((y) => y < toY)

        return (
          <Component
            key={url}
            planarTop={planarTop}
            planarBottom={planarBottom}
            planarLeft={planarLeft}
            planarRight={planarRight}
            top={top}
            bottom={bottom}
            left={left}
            right={right}
            xIsIncreasing={xIsIncreasing}
            yIsIncreasing={yIsIncreasing}
            vh={h}
            vw={w}
            navigate={navigate}
            {...props}
          />
        )
      })}
    </>
  )
}

export default Positioner
